import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';
import { GridDataSource, LoaderService, NotificationService, TOOLTIPS, ICONS, ACTIONS, EVENTO } from 'src/app/shared/session';
import { ZonaService } from '../shared/zona.service';

@Component({
  selector: 'app-zona-list',
  templateUrl: './zona-list.component.html',
})
export class ZonaListComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;
  @Input() titlePage: string;
  @Input() data: any;

  displayedColumns: string[] = ['ID', 'Region', 'Nombre'];
  dataSource: GridDataSource;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  buttonGroup: any;
  showMessageGridEmpty: boolean = false;

  constructor(
    private loaderService: LoaderService,
    private zonaService: ZonaService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.msgErrorGet = 'Error al listar zonas';
    this.buttonGroup = [
      { tooltip: TOOLTIPS.new, icon: ICONS.new, action: ACTIONS.new }
    ];
  }

  handleRowClick(row: any, event: any) {
    if (event.srcElement.cellIndex) {
      if (event.srcElement.cellIndex != 0) {
        this.selectedRowIndex = row.id;
        this.data.zona = { id: this.selectedRowIndex };
        this.changeEvent({ evento: EVENTO.consultar, data: this.data });
      }
    }
  }

  searchEmit(data: any) {
    this.buscarZona(data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  onNew() {
    this.changeEvent({ evento: EVENTO.crear, data: {} });
  }

  buscarZona(filtro: string) {
    this.listarZona(filtro);
  }

  fabButtonEmit(action: any) {
    switch (action) {
      case ACTIONS.new:
        this.onNew();
        break;
      default:
        break;
    }
  }

  listarZona(filtro: string): void {
    this.loaderService.show();
    this.zonaService.listarZona(filtro)
      .subscribe(res => {
        this.dataSource = new GridDataSource(res);
        this.showHideMessageGridEmpty(Number(res.length));
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }

  regionRowClick(cell: any) {
    this.selectedRowIndex = cell.id;
    this.data.zona = { id: cell.id, nombre: cell.nombre };
    this.changeEvent({ evento: EVENTO.asignar, data: this.data });
  }
}
